/* © CNES */
import { useQuery } from '@tanstack/react-query';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useState } from 'react';
import { getProcessingReport } from '../../../../api/processings/processings';
import { Processing } from '../../../../models/Processing';
import './ExecutionContext.scss';
import { LogContext } from './LogContext/LogContext';

/**
 * Execution Context displays an Execution log for each job.
 * @param contextInfoDetails a list of processings.
 * @returns Element.
 */
export const ExecutionContext = ({
  contextInfoDetails,
}: {
  contextInfoDetails: Processing | undefined;
}) => {
  const [visible, setVisible] = useState(false);
  const { data } = useQuery(
    [
      'getProcessingReport',
      {
        jobId: contextInfoDetails?.jobID ?? '',
      },
    ],
    getProcessingReport,
    { enabled: !!contextInfoDetails?.jobID }
  );

  return (
    <>
      <Dialog
        header="Execution log"
        visible={visible}
        style={{ width: '50vw' }}
        onHide={() => setVisible(false)}
      >
        <LogContext executionReport={data}></LogContext>
      </Dialog>
      <div key={contextInfoDetails?.jobID}>
        <div className="infoContextGray">
          <div className="nameAttribut">ID</div>
          <div className="responseAttribut">{contextInfoDetails?.jobID}</div>
        </div>
        <div className="infoContextWhite">
          <div className="nameAttribut">Title</div>
          <div className="responseAttribut">
            {contextInfoDetails?.titleProcess}
          </div>
        </div>
        <div className="infoContextGray">
          <div className="nameAttribut">Processing Name</div>
          <div className="responseAttribut">
            {contextInfoDetails?.processID}
          </div>
        </div>
        <div className="infoContextWhite">
          <div className="nameAttribut">Starting Time</div>
          <div className="responseAttribut">
            {contextInfoDetails?.job_start_datetime}
          </div>
        </div>
        <div className="infoContextGray">
          <div className="nameAttribut">Ending Time</div>
          <div className="responseAttribut">
            {contextInfoDetails?.job_end_datetime}
          </div>
        </div>
        <div className="infoContextWhite">
          <div className="nameAttribut">Status</div>
          <div className="responseAttribut">{contextInfoDetails?.status}</div>
        </div>
        <div className="infoContextGray">
          <div className="nameAttribut">Message</div>
          <div className="responseAttribut">{contextInfoDetails?.message}</div>
        </div>
        <div className="infoContextWhite">
          <div className="nameAttribut">Input Parameters</div>
          <div className="responseAttribut">
            {contextInfoDetails?.parameters}
          </div>
        </div>
        <div className="infoContextGray">
          <div className="nameAttribut">Execution Log</div>
          <div>
            <Button
              className="buttonLog"
              label="View execution report"
              onClick={() => setVisible(true)}
              link
            />
          </div>
        </div>
      </div>
    </>
  );
};
